import React from 'react';
import './Stats.scss';

const Stats = ({ title, value, subtitle, background }) => (
    <div className="stats">
        <p>{title}</p>
        <h1>{value}</h1>
        <p>{subtitle}</p>
    </div>
);

export default Stats;



// WEBPACK FOOTER //
// ./src/components/ui/Stats/Stats.js